export default "__VITE_ASSET__36ce1370__"